export function handleTargetValueDataSource({
  dataSource,
  dispatch,
  hideLoaderType,
  setDataSource,
  resolve,
  setPropertiesDataType,
  propertiesDataKey = "auditPropertiesData",
  dataSourceKey = "targetValue1DataSource",
}) {
  let result = dataSource;
  dispatch({
    type: hideLoaderType,
    data: { isDisableFocusState: false },
  });
  setDataSource(result);
  resolve({
    data: result,
    totalCount: result?.length,
  });
  dispatch({
    type: setPropertiesDataType,
    data: {
      [propertiesDataKey]: {
        [dataSourceKey]: [],
      },
    },
  });
}